import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '@shared/models/pagination.model';
import { BaseService } from '@shared/services/base.service';

import {
  StockCollectionHistoryListContent,
  StockCollectionHistorySearchCriteria,
  StockCollectionHistoryViewResponse
} from '../model/stock-collection-history.model';

@Injectable({
  providedIn: 'root'
})
export class StockCollectionHistoryService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.stockCollectionHistory;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getStockCollectionHistoryList(criteria: StockCollectionHistorySearchCriteria) {
    const params = this.getParams(criteria);
    const url = this.getFullUrlWithStoreNo(this.envService.list);
    return this.http.get<Pagination<StockCollectionHistoryListContent>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  getStockCollectionHistoryView(docNo: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.view, { docNo });
    return this.http.get<StockCollectionHistoryViewResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  getStockCollectionHistoryFileUrl(filePath: string) {
    const url = this.getFullNestUrl(this.envService.fileUrl, { filePath });
    return this.http.post<{ signedUrl: string }>(
      url,
      { filePath },
      {
        headers: this.loaderHeaders(null),
        observe: 'body'
      }
    );
  }
}
